import { useSelector } from "react-redux";
import { Box, Typography, Alert, Chip } from "@mui/material";
import { FormExtraction } from "../../../../interface/returns";
import { RootState } from "../../../../configureStore";

interface FormHeaderProps<T> {
    formName: string;
    formData: FormExtraction<T>;
    currentExtraction: any;
    formPageNumber: number;
    totalPages?: number;
}

const FormHeader = <T,>({ formName, formData, currentExtraction, formPageNumber, totalPages }: FormHeaderProps<T>) => {
    const hasChanges = useSelector<RootState, boolean>(({ returns }) => returns.hasChanges);
    // const theme = useTheme();
    // const importantBorderColor = theme.palette.mode === "dark" ? "#ffb74d" : "#f57c00";

    return (
        <Box>
            {formData.error && (
                <Alert
                    severity="error"
                    sx={{ mb: 2 }}
                >
                    Extraction Error: {formData.error}
                    <Typography
                        variant="body2"
                        sx={{ mt: 1 }}
                    >
                        Please fill in the form manually.
                    </Typography>
                </Alert>
            )}

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, flexWrap: "wrap" }}>
                <Typography variant="h6">
                    {formName}
                    {totalPages && totalPages > 1 ? ` - Page ${formPageNumber}` : ""}
                </Typography>
                {hasChanges && (
                    <Chip
                        label="Unsaved changes"
                        color="warning"
                        size="small"
                        variant="outlined"
                    />
                )}
                {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
                    <Box
                        sx={{
                            width: 12,
                            height: 12,
                            border: `2px solid ${importantBorderColor}`,
                            borderRadius: 0.5,
                        }}
                    />
                    <Typography
                        variant="caption"
                        sx={{ color: theme.palette.text.secondary }}
                    >
                        Important fields
                    </Typography>
                </Box> */}
            </Box>

            {!currentExtraction && (
                <Alert
                    severity="info"
                    sx={{ mb: 2 }}
                >
                    No extraction data available. Please enter data manually.
                </Alert>
            )}
        </Box>
    );
};

export default FormHeader;
